<template>
  <v-dialog v-model="showing" width="90vw" max-width="500px" scrollable>
    <v-card class="mx-auto" height="70vh">
      <v-sheet class="pa-4 primary">
        <v-text-field
          v-model="search"
          placeholder="Encontrar tópicos"
          flat
          dark
          solo-inverted
          hide-details
          clear-icon="mdi-close-circle-outline"
        ></v-text-field>
      </v-sheet>
      <v-card-text>
        <v-treeview
          :items="filteredElements"
          :open="filteredKeys"
          :active.sync="active"
          open-all
          activatable
          open-on-click
          transition
          hoverable
          style="overflow-y: auto"
        >
          <template v-slot:prepend="{ item }" @click="didTapItem(item)">
            <v-icon
              v-if="item.children"
              v-text="`${iconFromID(item.id)}`"
            ></v-icon>
            <v-icon
              v-if="item.url"
              v-text="`get_app`"
            ></v-icon>
          </template>
        </v-treeview>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { db } from '@/firebase/db';

export default {
  mounted() {
    this.$bind('atlases', db.collection('atlas').orderBy('name'));
    this.$bind('videos', db.collection('videos').orderBy('name'));
    this.$bind('exams', db.collection('exams').orderBy('name'));
    this.$bind('exercises', db.collection('exercises').orderBy('name'));
  },
  props: {
    showDialog: Boolean,
  },
  methods: {
    didTapItem(item) {
      this.$router.push(`atlas/${item.id}`);
    },
    iconFromID(id) {
      switch (id) {
        case 2:
          return 'school';
        case 3:
          return 'assignment_ind';
        case 4:
          return 'play_circle_fill';
        case 5:
          return 'edit';
        default:
          return 'folder';
      }
    },
    determineCollection(id) {
      let found = this.atlases.find(element => element.id === id);

      if (found) {
        return 'atlas';
      }

      found = this.videos.find(element => element.id === id);

      if (found) {
        return 'videos';
      }

      found = this.exercises.find(element => element.id === id);

      if (found) {
        return 'exercises';
      }

      return 'exames';
    },
  },
  data: () => ({
    atlases: [],
    videos: [],
    exams: [],
    exercises: [],
    search: '',
    caseSensitive: false,
  }),
  computed: {
    active: {
      get() {
        return [];
      },
      set(v) {
        if (v[0] !== undefined) {
          const collection = this.determineCollection(v[0]);
          if (collection === 'exercises') {
            const exercise = this.exercises.find(element => element.id === v[0]);
            window.open(exercise.url);
          } else {
            this.$router.push(`/${collection}/${v[0]}`);
            this.showing = false;
          }
        }
      },
    },
    items() {
      return [
        {
          id: 2,
          name: 'Atlas',
          children: this.atlases,
        },
        {
          id: 3,
          name: 'Exames',
          children: this.exams,
        },
        {
          id: 5,
          name: 'Exercícios',
          children: this.exercises,
        },
        {
          id: 4,
          name: 'Vídeos',
          children: this.videos,
        },

      ];
    },
    showing: {
      get() {
        return this.$props.showDialog;
      },
      set() {
        this.$emit('didCloseDialog');
      },
    },
    filteredElements() {
      if (this.search === '') {
        return this.items;
      }
      return this.items.reduce((acc, curr) => {
        const childrenContain = curr.children.filter((child) => {
          const index = child.name.toLowerCase().indexOf(this.search) >= 0;
          return index;
        });
        if (childrenContain.length) {
          acc.push({
            ...curr,
            children: [
              ...childrenContain,
            ],
          });
        }

        return acc;
      }, []);
    },
    filteredKeys() {
      return this.filteredElements.map(top => top.id);
    },
  },
};
</script>
